







import { Component, Vue } from 'vue-property-decorator';
import ForgetYourPassword from "@/components/ForgetYourPassword.vue";

@Component({
  components: {
    ForgetYourPassword
  }
})
export default class StudentsForgetYourPassword extends Vue {
  created() {
    console.log('created');
  }
}
